"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    animation: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject(), function (props) {
  return props.animation;
});

function template() {
  var _this$props = this.props,
      children = _this$props.children,
      hintRender = _this$props.hintRender,
      className = _this$props.className,
      onTargetClick = _this$props.onTargetClick,
      animateOverlay = _this$props.animateOverlay,
      out = this.state.out,
      _this$compileStyled = this.compileStyled(_index["default"]),
      root = _this$compileStyled.root,
      overlay = _this$compileStyled.overlay,
      pulsar = _this$compileStyled.pulsar,
      placeholder = _this$compileStyled.placeholder,
      childWrapper = _this$compileStyled.childWrapper,
      onClickInterceptor = _this$compileStyled.onClickInterceptor,
      contentWrapperIn = _this$compileStyled.contentWrapperIn,
      contentWrapperOut = _this$compileStyled.contentWrapperOut,
      overlayIn = _this$compileStyled.overlayIn,
      overlayOut = _this$compileStyled.overlayOut,
      placeholderIn = _this$compileStyled.placeholderIn,
      placeholderOut = _this$compileStyled.placeholderOut,
      pulsarIn = _this$compileStyled.pulsarIn,
      pulsarOut = _this$compileStyled.pulsarOut;

  var hint = null,
      content = null,
      onClickInterceptorComponent = null,
      overlayAppear = overlayIn,
      overlayExit = overlayOut;

  if (!animateOverlay && typeof animateOverlay === 'boolean') {
    overlayAppear = '';
    overlayExit = '';
  } else if ((0, _typeof2["default"])(animateOverlay) === 'object') {
    var _animateOverlay$appea = animateOverlay.appear,
        appear = _animateOverlay$appea === void 0 ? true : _animateOverlay$appea,
        _animateOverlay$exit = animateOverlay.exit,
        exit = _animateOverlay$exit === void 0 ? true : _animateOverlay$exit;
    overlayAppear = appear ? overlayAppear : '';
    overlayExit = exit ? overlayExit : '';
  }

  if (typeof hintRender === 'function') {
    hint = hintRender({
      close: this.close
    });
  }

  if (typeof onTargetClick === 'function') {
    onClickInterceptorComponent = _react["default"].createElement(Div, {
      styles: onClickInterceptor,
      onClick: this.handleTargetClick
    });
  }

  if (_react["default"].Children.only(children)) {
    content = _react["default"].createElement(Div, {
      styles: root,
      className: className
    }, _react["default"].createElement(Div, {
      onAnimationEnd: out ? this.animationEnd : undefined,
      animation: out ? overlayExit : overlayAppear,
      styles: overlay
    }), _react["default"].createElement(Div, {
      styles: childWrapper
    }, _react["default"].createElement(Div, {
      styles: pulsar,
      animation: out ? pulsarOut : pulsarIn
    }), _react["default"].createElement(Div, {
      styles: placeholder,
      animation: out ? placeholderOut : placeholderIn
    }), children, onClickInterceptorComponent), _react["default"].createElement(Div, {
      animation: out ? contentWrapperOut : contentWrapperIn
    }, hint));
  } else {
    console.warn('Only one child allowed in TutorialHint');
  }

  return content;
}